import { useFeatureFlag } from '@/providers'
import { FeatureFlags } from '@/providers/FeatureFlagContext'
import PageTitle from '@components/PageTitle/PageTitle'
import { Box, Divider, Paper, Stack } from '@mui/material'
import DirectDeals from '@views/MarketBaskets/Reports/Stats/DirectDeals'

import AnalystCreatedCounts from './Charts/AnalystCreatedCounts'
import PackConversions from './Charts/PackConversions'
import SavingsPercentage from './Charts/SavingsPercentage'
import SixMonAvgStats from './Charts/SixMonAvgStats'
import TotalDailySavings from './Charts/TotalDailySavings'
import MonthlyBasketsCreated from './Stats/MonthlyBasketsCreated'
import MonthlyTotalMatches from './Stats/MonthlyTotalMatches'
import MonthlyTotalSavings from './Stats/MonthlyTotalSavings'
import MonthlyTotalSpend from './Stats/MonthlyTotalSpend'

export default function MarketBasketReports() {
	const actionCenterEnabled = useFeatureFlag(FeatureFlags.ActionCenter)

	return (
		<Box width="100%">
			<PageTitle title="Analytics" />

			<Stack spacing={4} sx={{ width: '100%', p: 4 }}>
				<Paper elevation={1}>
					<Stack direction="row" spacing={1} p="1rem">
						<MonthlyBasketsCreated />
						<Divider orientation="vertical" flexItem />
						<MonthlyTotalSpend />
						<Divider orientation="vertical" flexItem />
						<MonthlyTotalMatches />
						<Divider orientation="vertical" flexItem />
						<MonthlyTotalSavings />
					</Stack>
				</Paper>

				<Stack spacing={4}>
					<SavingsPercentage />
					<TotalDailySavings />
					{actionCenterEnabled && <PackConversions />}
					<Stack direction="row" spacing={4}>
						<SixMonAvgStats />
						<AnalystCreatedCounts />
					</Stack>
					<Stack direction="row" spacing={4}>
						{actionCenterEnabled && <DirectDeals />}
					</Stack>
				</Stack>
			</Stack>
		</Box>
	)
}
